export enum FormularzLabels {
    Przyjazd = 'Check-in',
    Wyjazd = 'Check-out',
    Pokoj = 'Room',
    Pokoje = 'Rooms',
    Osoby = 'Persons',
    Cena = 'Price',
    Doby = 'Doby',
    DoZaplaty = 'Payment',
    Imie = 'Name',
    Nazwisko = 'Surname',
    Email = 'Email Address',
    Telefon = 'Phone Number',
    X = 'x',
}

export enum FormikFieldNames {
    Imie = 'name',
    Nazwisko = 'surname',
    Email = 'email',
    Telefon = 'phone',

    Dowod = 'dowod',
    Adres = 'adres',
    ImoinaRodzicow = 'rodzice',
    DataUrodzenia = 'dataUrodzenia',
    MiejsceUrodzenia = 'miejsceUrodzenia',

    

}